module.exports = __webpack_public_path__ + "static/main2-en-41e3fda3446f7f21a3ffb70903065e9a.png";